import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PubnubService } from '../services/Pubnub.service';
import { ActivatedRoute } from '@angular/router';
import { Map, getInstance, UserData, UserType } from 'nextnavsdk';
import { firefighterData, policeData, emsData, securityData, e911CallerData } from '../../assets/data';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { filter, tap } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-dotapp',
    // standalone: true,
    // imports: [],
    templateUrl: './dotapp.component.html',
    styleUrl: './dotapp.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DotappComponent implements OnInit {
  uid: string;
  channelId: string;
  centreLat: any;
  centreLong: any;
  environment = environment;
  userLat: any;
  userLong: any;
  userHat: any;

  constructor(private http: HttpClient, private route: ActivatedRoute, private pubnub: PubnubService) {
    this.uid = this.route.snapshot.queryParams['uid'];
    this.channelId = 'lprxloc'; //this.route.snapshot.queryParams['channelId'] || this.route.snapshot.queryParams['channelid'] || 
    this.centreLat = this.route.snapshot.queryParams['centrelat'] || this.route.snapshot.queryParams['centreLat'];
    this.centreLong = this.route.snapshot.queryParams['centrelong'] || this.route.snapshot.queryParams['centreLong'];
    this.userLat = this.route.snapshot.queryParams['userlat'] || this.route.snapshot.queryParams['userLat'];
    this.userLong = this.route.snapshot.queryParams['userlong'] || this.route.snapshot.queryParams['userLong'];
    this.userHat = this.route.snapshot.queryParams['userhat'] || this.route.snapshot.queryParams['userHat'];
    if (this.userHat) {
      let regex = /(m|ft)$/;
      if (regex.test(this.userHat))
        this.userHat = this.userHat.split(regex)[1] == 'ft' ? this.userHat.split(regex)[0] * 0.3048 : this.userHat.split(regex)[0];

    }
    else {
      this.userHat = 1;
    }
  }
  svgToDataURL(svg: any) {
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  }
  createSVGIconWithText(text: any) {
    if (text == "")
      return `
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="12" fill="#ffffff" stroke="#5EB2E1" stroke-width="1"/>
<circle cx="12" cy="12" r="8" fill="#ff0000" stroke="#ff0000" stroke-width="1"/>
</svg>
`;
    else return `
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="9" fill="rgb(255, 255, 255)" stroke="black" stroke-width="1"/>
<text x="5" y="16" fill="black" font-weight="bold" font-size="9" font-family="Verdana">` + text + `</text>
</svg>
`;
  }
  ngOnInit(): void {
    let defaultLat = 37.79131;
    let defaultLng = -122.41020;
    let firstLoad = true;
    var _this = this;
    let nextnavMap: any;
    // var pinnacleInterface = getInstance(CryptoJS.AES.decrypt(this.environment.API_KEY, '3DApp').toString(CryptoJS.enc.Utf8));
    var pinnacleInterface = getInstance('f5CWhIHdcN5EjXhLVUOmM9AeBihSQeXr8DHuLfjf');
    pinnacleInterface.on('load', function (event: any) {
      nextnavMap = new Map('container', {
        mapOptions: {
          //center: [0, 1],
          zoom: 18
        }
      });
    });

    if (_this.channelId) {
      _this.pubnub.showCasePubnumInstantiateAndSubscribe(environment.dotpubkey, environment.dotsubkey, _this.channelId, _this.uid ? _this.uid : 'Test');
      // _this.pubnub.publish(_this.channelId, {"name":"rohit"});
      let position: any = {};
      _this.pubnub.addObserver(_this.channelId).subscribe(async (obj: any) => {
        if (obj.message) {
          obj.message = JSON.parse(obj.message)
          console.log(obj.message);
        }
        if (pinnacleInterface.isLoaded) {
          if (firstLoad) {
            if (_this.centreLat && _this.centreLong)
              pinnacleInterface.setMapLocation({ lat: Number(_this.centreLat), lng: Number(_this.centreLong), zoom: 18, orientation: 0 });
            else
              if (obj.message) if (obj.message.latitude && obj.message.longitude)
                pinnacleInterface.setMapLocation({ lat: Number(obj.message.latitude), lng: Number(obj.message.longitude), zoom: 18, orientation: 0 });
            firstLoad = false;
          }
          let userType = null;
          if (obj.message && obj.message.device_id) {
            let img = null;
            let userTypeEnum = null;
            if (userType == 2) {
              img = './assets/police.png';
              userTypeEnum = UserType.POLICE;
            }
            else if (userType == 1) {
              img = './assets/firefighter.png';
              userTypeEnum = UserType.FIREFIGHTER;
            }
            else if (userType == 3) {
              img = './assets/ems.png';
              userTypeEnum = UserType.EMS;
            }
            else if (userType == 4) {
              img = './assets/security.png';
              userTypeEnum = UserType.SECURITY;
            }
            else if (userType == 5) {
              img = './assets/e911caller.png';//_this.svgToDataURL(_this.createSVGIconWithText(""));
              userTypeEnum = UserType.E911USER;
            }
            else {
              img = './assets/smartphone.png';
              userTypeEnum = UserType.OTHER;
            }
            if (!position[obj.message.device_id]) {
              position[obj.message.device_id] = new UserData({
                id: obj.message.device_id,
                userType: userTypeEnum, imgPath: img, lat: obj.message.latitude,
                lng: obj.message.longitude,
                hat: obj.message.altitude ? obj.message.altitude : 0,
                // efl: 0,
                firstName: obj.message.device_id,
                lastName: '',
                timestamp: obj.message.timestamp_sec ? obj.message.timestamp_sec : 0
              });
              pinnacleInterface.addUser(position[obj.message.device_id]);
            }

            if (position[obj.message.device_id]) {
              if (obj.message && obj.message.latitude && obj.message.longitude) {
                obj.message.heightAboveTerrain = obj.message.altitude ? obj.message.altitude : 0;
                if (isFinite(obj.message.latitude) && Math.abs(obj.message.latitude) <= 90 && Math.abs(obj.message.longitude) <= 180 && Math.abs(obj.message.longitude) <= 180 && isFinite(obj.message.heightAboveTerrain)) {
                  pinnacleInterface.updateUserLocation({
                    id: obj.message.device_id,
                    lat: obj.message.latitude,
                    lng: obj.message.longitude,
                    hat: obj.message.isLocationUserPinned ? 1 : obj.message.heightAboveTerrain,
                    // efl: 0,
                    userType: userTypeEnum,
                    imgPath: img,
                    // firstName: obj.message.firstName,
                    // lastName: obj.message.lastName,
                    timestamp: obj.message.timestamp
                  });
                }
              }
            }
          }
          // console.log(obj.timeout);
          if (obj.timeout) {
            if (position && position[obj.uuid]) {
              pinnacleInterface.removeUser(obj.uuid);
              delete position[obj.uuid];
            }
          }
        }
      });
    }
    else if (_this.userLat && _this.userLong) {
      if (firstLoad) {
        pinnacleInterface.on('load', async function (event: any) {
          pinnacleInterface.setMapLocation({ lat: _this.centreLat ? Number(_this.centreLat) : Number(_this.userLat), lng: _this.centreLong ? Number(_this.centreLong) : Number(_this.userLong), zoom: 18, orientation: 200 });
          nextnavMap.on('load', async function (event: any) {
            pinnacleInterface.addUser(new UserData({
              id: 'id',
              userType: UserType.OTHER,
              imgPath: './assets/man.png',
              lat: Number(_this.userLat),
              lng: Number(_this.userLong),
              hat: Number(_this.userHat ? _this.userHat : 1),
              // efl: Math.round(_this.userHat / 3),
              firstName: "Guest", lastName: "User"
            }));
          });
        });
        firstLoad = false;
      }
    }
    setTimeout(function () {
      if (firstLoad) {
        if (pinnacleInterface.isLoaded)
          pinnacleInterface.setMapLocation({ lat: _this.centreLat ? Number(_this.centreLat) : defaultLat, lng: _this.centreLong ? Number(_this.centreLong) : defaultLng, zoom: 18, orientation: 0 });
        else
          pinnacleInterface.on('load', function (event: any) {
            pinnacleInterface.setMapLocation({ lat: _this.centreLat ? Number(_this.centreLat) : defaultLat, lng: _this.centreLong ? Number(_this.centreLong) : defaultLng, zoom: 18, orientation: 0 });
          });
        firstLoad = false;
      }
    }, 5000);
  }
}
